/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TaskListIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Task List',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M2 3v28a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1Zm30 27H4V4h28Z"
    />
    <path
      d="M9.55 15.917a1 1 0 0 1-.679-.266l-2.077-1.917a1 1 0 1 1 1.352-1.475l.005.005 1.311 1.211 4.28-5.039a1.002 1.002 0 0 1 1.53 1.294l-.006.006-4.954 5.833a1 1 0 0 1-.7.351ZM9.55 25.917a1 1 0 0 1-.679-.266l-2.077-1.917a1 1 0 0 1 1.357-1.47l1.311 1.211 4.28-5.039a1.002 1.002 0 0 1 1.53 1.293l-.006.007-4.954 5.833a1 1 0 0 1-.7.351Z"
    />
    <rect x="18" y="10" width="10" height="4" rx=".5" />
    <rect x="18" y="20" width="10" height="4" rx=".5" />
  </svg>`;
};
